import { Component } from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatListItem, MatListItemIcon, MatListItemTitle,MatNavList } from '@angular/material/list';
import { MatMenu,MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    standalone: true,
    imports: [
      MatIconButton,
      MatMenuTrigger,
      MatIcon,
      MatBadge,
      MatMenu,
      MatNavList,
      MatListItem,
      MatListItemIcon,
      MatListItemTitle,
    ],
})
export class NotificationComponent {
  messages = ['Server Error Reports', 'Server Error Reports', 'Server Error Reports'];
}
